import { createReducer } from "@reduxjs/toolkit";

import { initialValues } from "@components/TwoFactorsAuthModal/form";
import {
  getQr,
  getQrSuccess,
  getQrFailure,
  twoFactorsReset,
  completeTwoFactors,
  completeTwoFactorsSuccess,
  completeTwoFactorsFailure,
  enableTwoFactors,
  enableTwoFactorsSuccess,
  enableTwoFactorsFailure,
  disableTwoFactors,
  disableTwoFactorsSuccess,
  disableTwoFactorsFailure,
  toggleTwoFactorsModal,
} from "./actions";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isDisableSuccess: false,
  qr: undefined,
  ascii: undefined,
  base32: undefined,
  hex: undefined,
  otpauth_url: undefined,
  error: null,
  isModalVisible: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getQr.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getQrSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      error: initialState.error,
      isLoading: false,
    }))
    .addCase(getQrFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(enableTwoFactors.type, (state) => ({
      ...state,
      isLoading: true,
      error: initialState.error,
    }))
    .addCase(enableTwoFactorsSuccess.type, (state) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      error: initialValues.error,
    }))
    .addCase(enableTwoFactorsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(completeTwoFactors.type, (state) => ({
      ...state,
      error: null,
      isLoading: true,
    }))
    .addCase(completeTwoFactorsSuccess.type, (state, _action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      error: initialValues.error,
    }))
    .addCase(completeTwoFactorsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(disableTwoFactors.type, (state) => ({
      ...state,
      isLoading: true,
      isDisableSuccess: false,
      error: initialState.error,
    }))
    .addCase(disableTwoFactorsSuccess.type, (state) => ({
      ...state,
      isLoading: false,
      isDisableSuccess: true,
      error: initialValues.error,
    }))
    .addCase(disableTwoFactorsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isDisableSuccess: false,
      isLoading: false,
    }))
    .addCase(twoFactorsReset.type, () => ({
      ...initialState,
    }))
    .addCase(toggleTwoFactorsModal, (state, action) => ({
      ...state,
      isModalVisible: action.payload,
    }));
});
